import { API_URL } from '../../../app-config/constants';
import { SummaryType } from '../../react/components/ReviewCycleSummary/types';
import { post } from '../request';

const BASE_URL = `${API_URL}/review-cycle`;

export interface ReviewCycleSummaryRequest {
    reviewIds?: string[];
    type: SummaryType;
}

export function getReviewCycleSummary(cycleId: string, request: ReviewCycleSummaryRequest) {
    return post<string>(`${BASE_URL}/${cycleId}/summary`, { postData: request });
}
